import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { AppTranslateService } from '../services/translate.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth   = inject(AuthService);
  const router = inject(Router);
  const lang   = inject(AppTranslateService);
  const token  = auth.getToken();

  // Public token-based endpoints: skip auth entirely
  const isPublicTokenRequest = req.url.includes('/appointments/token/');

  if (req.headers.has('skip') || isPublicTokenRequest) {
    const headers = req.headers.has('skip') ? req.headers.delete('skip') : req.headers;
    const cleanReq = req.clone({
      headers,
      setHeaders: {
        Accept: 'application/json',
        'Accept-Language': lang.currentLang,
      },
    });

    return next(cleanReq);
  }

  // Tell the backend which language to render messages in (drives Laravel SetLocale middleware)
  const baseHeaders: Record<string, string> = {
    Accept: 'application/json',
    'Accept-Language': lang.currentLang,
  };
  const authReq = token
    ? req.clone({ setHeaders: { ...baseHeaders, Authorization: `Bearer ${token}` } })
    : req.clone({ setHeaders: baseHeaders });

  return next(authReq).pipe(
    catchError((err: HttpErrorResponse) => {
      // Prevent infinite loop: skip logout endpoint
      // Don't redirect on public pages (confirm, cancel, etc.)
      const isPublicRoute = router.url.startsWith('/confirm')
        || router.url.startsWith('/privacy')
        || router.url.startsWith('/terms');
      if (err.status === 401 && !req.url.includes('/auth/logout') && !isPublicRoute) {
        auth.logout();
        router.navigate(['/auth/login']);
      }
      return throwError(() => err);
    })
  );
};
